<template>
  <ElTableColumn
    :width="100"
    :resizable="false"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-slot="{ row: { paused, id } }" :resizable="false">
      <BidPauseStatusColumnContent
        :id="id"
        width="60"
        :is-hovered="id === currentHoveredRowId"
        :initial-paused="paused"
      />
    </template>
  </ElTableColumn>
</template>

<script>
import BidPauseStatusColumnContent from './BidPauseStatusColumnContent';

export default {
  name: 'BidPauseStatusColumn',
  components: {
    BidPauseStatusColumnContent,
  },
  inheritAttrs: false,
  props: {
    currentHoveredRowId: {
      type: Number,
      required: true,
    },
  },
};
</script>
